import * as React from 'react'

import * as styles from './ImagePreloader.css'

interface ImagePreloaderProps {
  images: string[]
}

const ImagePreloader: React.FunctionComponent<ImagePreloaderProps> = ({ images }) => {
  return (
    <div className={styles.none}>
      {images
        .filter(item => item)
        .map((image, index) => (
          <img key={`image-${index}`} src={image} />
        ))}
    </div>
  )
}

export default ImagePreloader
